import PropTypes from 'prop-types';
import React from 'react';

/**
 * AccountActions — Deactivate / Reinstate / Delete card for detail pages.
 * Copy comes from utils/accountActions.js so staff and member screens read the same.
 */
const AccountActions = ({ copy, isActive, canToggle, canDelete, onDeactivate, onReinstate, onDelete }) => {
  if (!canToggle && !canDelete) return null;

  return (
    <div className="border-top pt-4 mt-4">
      {canToggle && (
        <div className="mb-4">
          <h5 className="mb-1">{isActive ? 'Deactivate' : 'Reinstate'}</h5>
          <p className="text-muted mb-3">{isActive ? copy.deactivate.description : copy.reinstate.description}</p>
          {isActive ? (
            <button type="button" className="btn btn-outline-warning" onClick={onDeactivate}>
              <i className="mdi mdi-account-off-outline me-1" />
              Deactivate
            </button>
          ) : (
            <button type="button" className="btn btn-success" onClick={onReinstate}>
              <i className="mdi mdi-account-check-outline me-1" />
              Reinstate
            </button>
          )}
        </div>
      )}
      {canDelete && (
        <div>
          <h5 className="text-danger mb-1">Danger zone</h5>
          <p className="text-muted mb-3">{copy.remove.description}</p>
          <button type="button" className="btn btn-danger" onClick={onDelete}>
            <i className="mdi mdi-trash-can-outline me-1" />
            {copy.remove.title}
          </button>
        </div>
      )}
    </div>
  );
};

AccountActions.propTypes = {
  copy: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  canToggle: PropTypes.bool,
  canDelete: PropTypes.bool,
  onDeactivate: PropTypes.func,
  onReinstate: PropTypes.func,
  onDelete: PropTypes.func,
};

export default AccountActions;
